const name = "Lundgrens i Gräfsnäs";

export default {
  titleTemplate: `%s | ${name}`,
  defaultTitle: `${name}`,
  defaultDescription: '',
  siteName: name,
  twitterName: 'lundgrensigrafs',
}